import Vue from 'vue'
import Router from 'vue-router'
// 问卷调查
import questionnaire from '@/views/survey/questionnaire'
// 问卷状态
import statusPage from '@/views/survey/statusPage'


// 绑定手机号(公共号)
import bindPhone from '@/views/invitation/bindPhone'
// 绑定成功(公共号)
import bindFinish from '@/views/invitation/bindFinish'
// 引导下载页(受邀人打开)
import downLoad from '@/views/invitation/downLoad'
// 用户协议
import userAgreement from '@/views/other/userAgreement'
// 用户注销协议
import userCancellation from '@/views/other/userCancellation'
// 隐私政策
import privacyPolicy from '@/views/other/privacyPolicy'
import sdkInfo from '@/views/other/sdkInfo'
// 帮助中心
import help from '@/views/other/help'


import test from '@/views/survey/test'



Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/survey/',
  routes: [
    {
      path: '/questionnaire',
      name: '问卷调查',
      component: questionnaire,
      meta: {
        keepAlive: false,
      }
    },
    {
      path: '/statusPage',
      name: '问卷状态',
      component: statusPage
    },
    {
      path: '/bindPhone',
      name: '绑定手机号',
      component: bindPhone
    },
    {
      path: '/bindFinish',
      name: '绑定成功',
      component: bindFinish
    },
    {
      path: '/downLoad',
      name: '引导下载页',
      component: downLoad
    },
    {
      path: '/userAgreement',
      name: '用户协议',
      component: userAgreement
    },
    {
      path: '/userCancellation',
      name: '用户注销协议',
      component: userCancellation
    },
    {
      path: '/privacyPolicy',
      name: '隐私政策',
      component: privacyPolicy
    },
    {
      path: '/sdkInfo',
      name: '涉及收集用户信息的第三方SDK列表',
      component: sdkInfo
    },
    {
      path: '/help',
      name: '帮助中心',
      component: help
    },
    {
      path: '/test',
      name: '测试',
      component: test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js